import React, { Fragment, useState, createContext } from 'react';
import { Toolbar } from './Toolbar';

interface CodeTabsProps {
  children: React.ReactElement[];
}

export const CodeTabsContext = createContext({
  isInCodeTabs: false,
});

const CodeTabs = ({ children }: CodeTabsProps) => {
  if (!children) return null;
  const [activeTab, setActiveTab] = useState(children[0].props.label);

  const tabs: string[] = children.map((child) => child.props.label);
  return (
    <CodeTabsContext.Provider value={{ isInCodeTabs: true }}>
      <div className="code-tabs">
        <Toolbar active={activeTab} tabs={tabs} setActive={setActiveTab} />
        {children.map((child, i) => {
          if (child.props.label !== activeTab) return null;
          return (
            <Fragment key={child.props.label || i}>
              {child.props.children}
            </Fragment>
          );
        })}
      </div>
    </CodeTabsContext.Provider>
  );
};

interface CodeTabProps {
  label: string;
  children: React.ReactNode;
}

const CodeTab = ({ children }: CodeTabProps) => {
  return <>{children}</>;
};

export { CodeTabs, CodeTab };
